import { OMGLogger } from "../util/OMGLogger";

var gameanalytics = require('gameanalytics');

const defaultConfig = [
    {key: "aE", value: "true"}, //Arcade Enabled, default: true
    {key: "gO", value: "3012"}, //Arcade game order: from 0-3, first digit: INSTRUMENT, second digit: BURGER, third digit: DISTRACTION, fourth digit: GRID_FILL
    {key: "gB", value: "0.96;25;27;8"}, //BURGER: durationMultiplier ; baseTime (multiply by 100) ; defaultTimePerIngredient (multiply by 100) ; minimumTimePerIngredient (multiply by 100)
    {key: "gD", value: "80;30;18;80;35"}, //DISTRACTION: timeToReachEnd (multiply by 1000) ; defaultScoreSpeed ; activeDistractionSpeedChange ; startSpawnTimeMultiplier
    {key: "gG", value: "0.96;4;250;100"}, //GRID_FILL: durationMultiplier ; defaultShapeCount ; defaultDuration (multiply by 100) ; minimumDuration (multiply by 100)
    {key: "hBe", value: "true"}, //home button enabled
];

export class RemoteConfigPlugin extends Phaser.Plugins.BasePlugin{

    private remoteConfigsAvailable : boolean;
    private configsCallback !: () => void;

    private initialized : boolean;

    constructor(pluginManager: Phaser.Plugins.PluginManager) {
        super(pluginManager);

        this.remoteConfigsAvailable = false;
        this.initialized = false;
    }

    initialize(){        
        var myRemoteConfigsListener = {
            onRemoteConfigsUpdated: () => {this.onRemoteConfigUpdated()}
        };
        
        gameanalytics.GameAnalytics.addRemoteConfigsListener(myRemoteConfigsListener);

        this.initialized = true;
    }

    private onRemoteConfigUpdated(){
        this.remoteConfigsAvailable = true;
        this.logConfigs();

        if (this.configsCallback) {
            this.configsCallback();
        }
    }

    private logConfigs(){
        OMGLogger.Debug("REMOTE CONFIGS ");
        OMGLogger.Debug("aE: " + this.getConfig("aE"));
        OMGLogger.Debug("gO: " + this.getConfig("gO"));
        OMGLogger.Debug("gB: " + this.getConfig("gB"));
        OMGLogger.Debug("gD: " + this.getConfig("gD"));
        OMGLogger.Debug("gG: " + this.getConfig("gG"));
    }

    public configsAvailable(){
        return this.remoteConfigsAvailable;
    }

    public setConfigsCallback(cb: () => void){
        this.configsCallback = cb;
    }

    public getConfig(key: string, forceDefault: boolean = false){
        let defaultValue = defaultConfig.filter( dc => {return dc.key == key})[0];
        if (forceDefault){
            return defaultValue.value;
        }

        return gameanalytics.GameAnalytics.getRemoteConfigsValueAsString(key, defaultValue.value);
    }
}